var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29839 8.0006L6.29985 4.97685C6.07792 4.75276 6.07792 4.39135 6.29985 4.16726C6.4056 4.06021 6.54985 4 6.7003 4C6.85075 4 6.99499 4.06021 7.10074 4.16726L10.4997 7.59521C10.7224 7.81904 10.7224 8.18095 10.4997 8.40479L7.10088 11.8327C6.99499 11.9398 6.85075 12 6.7003 12C6.54985 12 6.4056 11.9398 6.29971 11.8327C6.07792 11.6086 6.07792 11.2472 6.29999 11.0232L9.29839 8.0006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.c639a5b5f03800b789b6272dcc405341.svg";
export { ForwardRef as ReactComponent };